import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react'

/**
 * Landing page Clerk redirects to after OAuth (GitHub) finishes.
 * `<AuthenticateWithRedirectCallback>` exchanges the code, sets the session,
 * then forwards the browser to the `redirectUrlComplete` we passed when
 * starting the flow. No UI — by design, this page should never linger.
 */
export function SsoCallbackPage() {
  return <AuthenticateWithRedirectCallback />
}
